import * as React from 'react';
import { Outside, Popover } from '@cian/ui-kit';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';

import * as styles from './FavoriteTooltip.css';

const ANIMATION_DURATION = 250;

// TODO: Если эксперимент победит, перенести desktop notification UI в @cian/favorites-assign-widget.
type TFavoriteTooltipProps = {
  children: React.ReactElement;
  isOpen: boolean;
  variant: 'error' | 'success';
  onAddToFolder?(event: React.MouseEvent<HTMLButtonElement>): void;
  onClose(): void;
  onFavoritesLinkClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
};

export const FavoriteTooltip: React.FC<TFavoriteTooltipProps> = ({
  children,
  isOpen,
  variant,
  onAddToFolder,
  onClose,
  onFavoritesLinkClick,
}) => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [isMounted, setMounted] = React.useState(isOpen);
  const [mountedVariant, setMountedVariant] = React.useState(variant);

  React.useEffect(() => {
    if (isOpen) {
      setMountedVariant(variant);
      setMounted(true);

      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setMounted(false);
    }, ANIMATION_DURATION);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isOpen, variant]);

  const displayedVariant = isOpen ? variant : mountedVariant;

  return (
    <Popover
      content={
        <Outside active={isOpen} insideRefs={[anchorRef]} onOutside={onClose}>
          <div
            className={clsx(
              styles['tooltip'],
              styles[displayedVariant],
              isOpen ? styles['tooltip-visible'] : styles['tooltip-hidden'],
            )}
            data-name="RedesignedFavoriteTooltip"
            data-state={isOpen ? 'visible' : 'hidden'}
            data-variant={displayedVariant}
            role={displayedVariant === 'error' ? 'alert' : undefined}
          >
            {displayedVariant === 'error' ? (
              <span className={styles['message']}>Не удалось добавить в избранное</span>
            ) : (
              <>
                <span className={styles['message']}>
                  Сохранили в{' '}
                  <a className={styles['favorites-link']} href="/favorites/" onClick={onFavoritesLinkClick}>
                    избранное
                  </a>
                </span>
                <button className={styles['button']} type="button" onClick={onAddToFolder}>
                  <IconActionPlus16 color="icon-main-default" display="block" aria-hidden />
                  <span>Добавить в подборку</span>
                </button>
              </>
            )}
          </div>
        </Outside>
      }
      flip={false}
      open={isMounted}
      placement="bottom-end"
      preventOverflow={false}
    >
      <div ref={anchorRef}>{children}</div>
    </Popover>
  );
};
